$(window).on("load", function () {
  console.log('SLIDER PRESSSSSSSE')
  const sliderLength = $(".press-item").length
  console.log(sliderLength);
  if ($(".press").length) {
    $(".press-citations").slick({
      dots: true,
      infinite: true,
      arrows: false,
      fade: true,
      asNavFor: ".press-logos",
    });
    $(".press-logos").slick({
      dots: false,
      infinite: false,
      arrows: false,
      fade: false,
      slidesToShow: 5,
      asNavFor: ".press-citations",
      centerMode: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            infinite: true,
            slidesToShow: 1,
          },
        },
      ],
    });
    $(".press-logos")
      .find(".dot")
      .on("click", function () {
        slide_index = $(this).data("index");
        $(".press-citations").slick("slickGoTo", slide_index - 1);
        $(".press-item").removeClass('active');
        $(this).addClass('active');
      });
      $(".press-citations").on("beforeChange", function (event, slick, currentSlide, nextSlide){
          $(".press-item").removeClass('active');
          // console.log('Current slide', currentSlide)
          // console.log('Next Slide', nextSlide)
          if (nextSlide == sliderLength - 1) {
            console.log("Slide au dernier");
            slideIndex = sliderLength;
          } else if ((nextSlide == 0)) {
            console.log("Slide au premier");
            slideIndex = 1;
          } else {
            console.log("Slide aux autres");
            slideIndex = nextSlide+1;
          }
          $('.press-item[data-index='+slideIndex+']').addClass('active');
      })
  }
});
